import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LocalizzazioneService {
  private BASE_URL = 'api/tipologiche/';

  constructor(
    private http: HttpClient
  ) {}

  getNazioni(): Observable<any> {
    const apiUrl = `${this.BASE_URL}Nazioni`;
    return this.http.get(
      apiUrl
    );
  }

  getComuniFiscali(value: string): Observable<any> {
    const val = value.toUpperCase();
    // const apiUrl = `${this.BASE_URL}Comuni?$filter=startswith(Descrizione,'${val.replace(/\'/g, '%27%27')}')`;
    const apiUrl = `${this.BASE_URL}Comuni/${val}`;
    return this.http.get(apiUrl)
      .pipe(tap((data: any) => data));
  }

  filterLocalizzazioneBySigla(sigla: string, data: Array<any>, id: string): Observable<any[]> {
    const filtered = data.filter(e => e[id] === sigla);
    return of(filtered);
  }
}
